import { createSelector } from '@reduxjs/toolkit';

export const getDietaryRequirementsState = (state) => state.dietaryRequirements;

export const getDietaryRequirements = createSelector(
  getDietaryRequirementsState,
  (dietaryRequirementsState) => dietaryRequirementsState.data,
);
